import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-smartfeed-power-status',
  templateUrl: './smartfeed-power-status.component.html',
  styleUrls: ['./smartfeed-power-status.component.scss'],
})
export class SmartfeedPowerStatusComponent implements OnInit {
  @Input()
  adapterStatus: 0 | 1;

  @Input()
  batteryVoltage: number;

  @Input()
  batteriesStatus: 0 | 1;
  constructor() {}

  ngOnInit() {}

  getSource() {
    return this.adapterStatus === 0 && this.batteriesStatus === 0
      ? 'No Power Source'
      : this.adapterStatus === 1 && this.batteriesStatus === 0
      ? 'Adapter Only'
      : this.adapterStatus === 0 && this.batteriesStatus === 1
      ? 'Batteries Only'
      : 'Adapter and Battery';
  }
}
